import React from "react";
import "./button.scss";
import { Link } from "react-router-dom";
import classnames from "classnames";

function Button(props) {
  return (
    <Link
      to={props.path}
      className={classnames("btn", props.type, "text-uppercase")}
      role="button"
    >
      <span>{props.title}</span>
    </Link>
  );
}

export default Button;
